"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsButtonAvailableOffline = void 0;
const device_1 = require("@completeanatomy/device");
const odr_1 = require("@completeanatomy/odr");
const constants_1 = require("../constants");
function useIsButtonAvailableOffline(identifier) {
    const isOffline = (0, device_1.useIsDeviceOffline)();
    const isDiversityCached = (0, odr_1.useIsCurrentDiversityResourcesCached)();
    if (!isOffline) {
        return true;
    }
    if (identifier === constants_1.SystemIdentifier.Urogenital ||
        identifier === constants_1.SystemIdentifier.Integumentary) {
        return isDiversityCached;
    }
    return true;
}
exports.useIsButtonAvailableOffline = useIsButtonAvailableOffline;
